import { render, staticRenderFns } from "./Accumulation.vue?vue&type=template&id=3742b5a2&scoped=true"
import script from "./Accumulation.vue?vue&type=script&lang=js"
export * from "./Accumulation.vue?vue&type=script&lang=js"
import style0 from "./Accumulation.vue?vue&type=style&index=0&id=3742b5a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3742b5a2",
  null
  
)

export default component.exports